import * as React from "react";

import { Badge } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { LoginTabContext } from "../../../contexts/LoginTabContext";

const Tabs = ({ children, labels = [], sx, ...props }) => {
  const { valueTab, setValueTab } = React.useContext(LoginTabContext);

  const childrenArray = Array.isArray(children) ? children : [children];

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };

  React.useEffect(() => {
    return () => {
      // every time the component unmounts we reset the tab context valueTab to "1"
      setValueTab("1");
    };
  }, []);

  return (
    <Box sx={sx}>
      <TabContext value={valueTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            {labels?.map((label, i) => (
              <Tab
                key={i}
                value={(i + 1).toString()}
                label={
                  <Badge
                    badgeContent={label.badgeCount}
                    color="primary"
                    max={label.max || 99}
                  >
                    {label.text}
                  </Badge>
                }
              />
            ))}
          </TabList>
        </Box>
        {childrenArray?.map((child, i) => (
          <TabPanel key={i} value={(i + 1).toString()}>
            {child}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default Tabs;
